import { NgModule } from '@angular/core';
import { NgAggregatePipesModule } from './aggregate';
import { NgArrayPipesModule } from './array';
import { NgBooleanPipesModule } from './boolean';
import { NgMathPipesModule } from './math';
import { NgObjectPipesModule } from './object';
import { NgStringPipesModule } from './string';
var NgPipesModule = (function () {
    function NgPipesModule() {
    }
    return NgPipesModule;
}());
export { NgPipesModule };
NgPipesModule.decorators = [
    { type: NgModule, args: [{
                exports: [
                    NgArrayPipesModule,
                    NgMathPipesModule,
                    NgBooleanPipesModule,
                    NgStringPipesModule,
                    NgObjectPipesModule,
                    NgAggregatePipesModule
                ]
            },] },
];
/** @nocollapse */
NgPipesModule.ctorParameters = function () { return []; };
// Export individual pipes and modules
export * from './aggregate';
export * from './array';
export * from './boolean';
export * from './math';
export * from './object';
export * from './string';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/index.js
// module id = 684
// module chunks = 103